import { actionNameGenerator } from '../../utils/commonUtil';

const domainPrefix = 'fa';
const faActions = actionNameGenerator(domainPrefix);

export const userDataFetchType = faActions('userDataFetch');

export const enableBackType = faActions('enableBack');

export const resetEnableBackType = faActions('resetEnableBack');

export const userDataLoadingType = faActions('userDataLoading');

export const userDataSuccessType = faActions('userDataSuccess');

export const userDataFailedType = faActions('userDataFailed');

export const fetchLazyLoadDataType = faActions('lazyLoadDataFetch');

export const lazyLoaderType = faActions('lazyLoader');

export const lazyDataSuccessType = faActions('lazyDataSuccess');

export const lazyDataFailedType = faActions('lazyDataFailed');

export const resetAdvisorData = faActions('resetAdvisorData');
